<!-- 选择车系 -->
<template>
    <div id="chooseCarType">
        <div class="tabs-btn-ctn">
            <div class="tab-btn-item" @click="tabToggle(0)" :class="{'tab-active':tabInd == 0}">选择车型</div>
            <div class="tab-btn-item" @click="tabToggle(1)" :class="{'tab-active':tabInd == 1}">车系搜索</div>
        </div>
        <div class="nomal-tabs-content">
            <div class="nomal-tab-section" v-show="tabInd == 0 ">
                <!-- 步骤条 -->
                <div class="choose-progress">
                    <el-steps :active="active" simple>
                        <el-step title="选择品牌"></el-step>
                        <el-step title="选择车系"></el-step>
                        <!--<el-step title="选择排量"></el-step>-->
                        <!--<el-step title="生产年份"></el-step>-->
                        <!--<el-step title="选择车型"></el-step>-->
                    </el-steps>
                </div>
                <div class="choosed">
                    <span>已选车型：</span>
                    <span v-for="(item,index) in choosedData" class="choose-item" v-show="index != 2">
                        {{item}}
                        <i class="el-icon-close" @click="reChoose(index)"></i>
                        </span>
                </div>
                <!--选择品牌-->
                <div v-show="active == 0 ">
                    <div class="car-sort">
                        <div :class="['sort-item',nowInitials== -1 ?'active':'']" @click='typeToggle(-1)'>
                            热门品牌
                        </div>
                        <div :class="['sort-item',nowInitials== key?'active':'']"
                             v-for="(value,key) in brand"
                             @click='typeToggle(key)'
                        >
                            {{key}}
                        </div>
                    </div>
                    <div class="car-ctn">
                        <template v-if="nowCarType && nowCarType[0]">
                            <div v-for="item in nowCarType" class="car-item" @click="choosePP(item)">
                                <img :src="QN_URL_BASE+item.Logo" alt="" class="car-logo" :onerror="defaultImg">
                                {{item.Cn}}
                            </div>
                        </template>
                        <template v-else>
                            <div class="no-data">
                                暂无数据
                            </div>
                        </template>

                    </div>
                </div>
                <!--选择车系-->
                <div v-show="active == 1" class="sp-ctn">
                    <div v-for="(value,key) in carModelData">
                        <div class='car-orange'>{{key}}</div>
                        <div class="cx-ctn">
                            <div v-for="i in value" class="sp-item" @click="chooseCx(i)">
                                {{i.AutoSerieName}}
                            </div>
                        </div>
                    </div>
                </div>
                <!--选择排量-->
                <div v-show="active == 2" class="sp-ctn">
                    <div class="pl-ctn">
                        <div v-for="item in plData" class="sp-item" @click="choosePL(item)">
                            {{item.Emission}}
                        </div>
                    </div>
                </div>
                <!--生产年份-->
                <div v-show="active == 3" class="sp-ctn">
                    <div class="pl-ctn">
                        <div v-for="item in nfData" class="sp-item" @click="chooseNF(item)">
                            {{item.ProducedYear}}
                        </div>
                    </div>
                </div>
                <!--选择车型-->
                <div v-show="active == 5" class="sp-ctn choose-success">
                    车型选择成功
                </div>
            </div>
            <!-- 搜索 -->
            <div class="nomal-tab-section sp-ctn" v-show="tabInd == 1 ">
                <div class="search-ctn">
                    <el-input placeholder="请输入品牌或车系"
                              class="search-input"
                              v-model.trim="searchCarData.key"
                              @keyup.enter.native="searchCar(1)"
                    ></el-input>
                    <el-button slot="append" type="primary" class="btn-primary" icon="el-icon-search" @click="searchCar(1)">搜索</el-button>
                </div>
                <div v-if="searchResultLength != 0">
                    <div class="cx-ctn">
                        <div v-for="item in searchResult" class="sp-item" @click="chooseCx(item,'fromSearch')">
                            {{item.Cn}}/{{item.Emission}}/{{item.ProducedYear}}
                        </div>
                    </div>
                    <div class="dialog-pagination-ctn">
                        <el-pagination
                                @size-change="searchCarSizeChange"
                                @current-change="searchCarCurrentChange"
                                :current-page="searchCarData.page"
                                :page-sizes="[12, 20, 30, 40, 50]"
                                :page-size="searchCarData.limit"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="searchResultLength">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'chooseCarType',
        components: {

        },
        data(){
            return {
                searchCarData:{
                    key:'',
                    limit:12,
                    page:1,
                },
                searchResult:[],
                searchResultLength:0,
                searchData:{},
                defaultImg:'this.src="' + this.$util.DEFAULT_IMAGE + '"',
                QN_URL_BASE:this.$util.QN_URL_BASE,
                nowCarType:null, // 当前显示的车系
                nowInitials:'-1',  // 当前active索引
                choosedData:[], // 选中的数据
                active:0, // 步骤进度
                tabInd:0,
                nfData:[],
                plData:[], // 排量
                carModelData:{},  // 某品牌车的车系数据
                hot: [],  // 热门车型
                // 具体车型
                brand:{},
            }
        },
        mounted(){
            this.nowCarType = this.hot
            this.getData()
            this.getHotBrands()
        },
        methods:{
            // 重置已选项
            resetForm (){
                this.choosedData = [] // 选中的数据
                this.active = 0 // 步骤进度
                this.searchResult =[]
                this.tabInd = 0,
                this.searchCarData = {
                    key:'',
                    limit:12,
                    page:1,
                }
            },
            // 搜索车系
            searchCar(page){
                if (page){
                    this.searchCarData.page = page
                }
                this.axios.get('/Auto/SearchAutoSeries',{
                    params: this.searchCarData

                })
                    .then((response)=> {
                        let data = response.data.data
                        this.searchResult = data
                        this.searchResultLength = response.data.count
                        if (response.data.count == 0){
                            this.$util.warningMsg('无搜索结果')
                        }
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            // 返回首字母排序好的车品牌
            getData(){
                this.axios.get('/Auto/GetAllAutoBrands',{
                    params: this.searchData

                })
                    .then((response)=> {
                        let data = response.data.data
                        delete data.hot
                        this.brand = data
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            // 获取热门品牌
            getHotBrands(){
                this.axios.get('/Auto/GetHotAutoBrands')
                    .then((response)=> {
                        let data = response.data.data
                        this.hot = data
                        this.nowCarType = this.hot
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            // 根据品牌Id获取对应生产商的所有车系
            choosePP(item){
                this.choosedData.push(item.Cn)
                this.axios.get('/Auto/GetAutoSeriesByBId',{
                    params:{
                        BId:item.Id
                    }
                })
                    .then((response)=> {
                        let data = response.data.data
                        this.carModelData = data
                        this.active = 1;
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            // 选车系返回车系
            chooseCx(item,fromSearch){
                this.active = 5;
                if (fromSearch){
                    this.choosedData.push(item.Cn)
                    this.choosedData.push(item.Emission)
                    this.choosedData.push(item.Id)
                    this.$emit('chooseCar',this.choosedData)
                }
                else {
                    this.choosedData.push(item.AutoSerieName)
                    this.choosedData.push(item.AutoSerieId)
                    this.$emit('chooseCar',this.choosedData)
                }
            },
            // 切换最上面的tab
            tabToggle(i) {
                this.tabInd = i;
            },
            // 点击x
            reChoose(i){
                let _choosedData = this.choosedData
                switch (i) {
                    case 0:
                        this.choosedData = []
                        this.active = 0
                        break
                    case 1:
                        this.choosedData = _choosedData.slice(0,1)
                        this.active = 1
                        break
                    case 2:
                        this.choosedData = _choosedData.slice(0,2)
                        this.active = 2
                        break
                    case 3:
                        this.choosedData = _choosedData.slice(0,3)
                        this.active = 3
                        break
                    case 4:
                        this.choosedData = _choosedData.slice(0,4)
                        this.active = 4
                        break
                }
            },
            // 切换选择品牌索引
            typeToggle(index) {
                this.nowInitials = index;
                if (index == -1){
                    this.nowCarType = this.hot
                    return
                }
                let _brand = this.brand;
                for (let key in _brand){
                    if (key == index){
                        this.nowCarType = _brand[key]
                    }

                }
            },
            searchCarSizeChange(val) {
                this.searchCarData.limit = val
                this.searchCar()
            },
            searchCarCurrentChange(val) {
                this.searchCarData.page = val
                this.searchCar()
            },
        }
    }
</script>
<style lang="less" scoped>
    .tabs-btn-ctn{
        border-bottom: 1px solid @border1Color;
        .tab-btn-item {
            flex-grow: 0;
            width: 120px;
            padding: 0 10px;
            border-bottom: none;
        }
    }
    .choose-progress {
        padding: 20px 20px 20px 0 ;
    }
    .choose-item {
        border: 1px solid @theme;
        padding: 5px 10px;
        margin-right: 10px;
        i {
            cursor: pointer;
        }
    }
    .car-sort {
        padding: 20px 0;
        display: flex;
    }
    .active {
        background: @theme;
        color: #fff;
    }
    .sort-item {
        padding: 5px 10px;
        font-weight: bold;
        cursor: pointer;
    }
    .car-ctn {
        display: flex;
        flex-wrap: wrap;
    }
    .car-item {
        display: flex;
        align-items: center;
        width: 165px;
        height: 52px;
        border: 1px solid @border1Color;
        margin-bottom: 20px;
        margin-right: 20px;
        cursor: pointer;
        &:hover {
            border: 1px solid @theme;
        }
    }
    .car-logo {
        width: 30px;
        height: 30px;
        margin: 0 20px 0 30px;
    }
    .sp-ctn {
        padding-top: 20px;
    }
    .car-orange {
        background: @border4Color;
        padding: 10px 20px;
        border-left:5px solid @theme ;
        margin-bottom: 10px;
    }
    .cx-ctn {
        display: flex;
        flex-wrap: wrap;
    }
    .sp-item {
        width: 162px;
        line-height: 52px;
        border: 1px solid @border4Color;
        text-align: center;
        margin: 0 10px 10px 0;
        cursor: pointer;
        &:hover {
            border: 1px solid @theme;
        }
    }
    .pl-ctn {
        display: flex;
    }
    .choose-success {
        font-size: @font-lg;
        line-height: 80px;
        text-align: center;
    }
    .search-ctn {
        height: 60px;
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
    }
    .search-input {
        width: 80%;
        margin-right: 10px;
    }
    .no-data {
        width: 100%;
        line-height: 100px;
        text-align: center;
    }
</style>
